<template>
  <v-card outlined class="px-4 py-6 mx-4 my-4 elevation-0">
    <v-row class="flex-center-between">
      <v-col v-if="true" cols="12" md="3" lg="4">
        <div class="text">Mô tả</div>
        <div class="description">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{ club.description || '' }}</span>
            </template>
            <span>{{ club.description }}</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col cols="12" md="1" lg="2">
        <div class="text">Số học sinh tối đa</div>
        <div class="text-name mt-2">{{ club.maxMembers }}</div>
      </v-col>
      <v-col cols="12" md="1" lg="2">
        <div class="text">Số học sinh hiện tại</div>
        <div class="text-name mt-2">{{ club.countMembers }}</div>
      </v-col>
      <v-col cols="12" md="2" lg="2">
        <div class="text">Trạng thái</div>
        <v-chip class="mt-2 text--white" small :color="club.isOpenRegister ? 'success' : 'warning'">
          <span class="mr-1">
            {{ club.isOpenRegister ? 'Đã mở đăng kí' : 'Đang đóng đăng kí' }}
          </span>
        </v-chip>
      </v-col>

      <v-col cols="12" md="2" lg="2" class="d-flex justify-end align-center">
        <v-btn
          class="v-btn--outlined theme--light v-size--small primary--text font-weight-bold"
          depressed
          @click="$refs.dialogInfoView.openDialog()"
        >
          Xem chi tiết
        </v-btn>
      </v-col>
    </v-row>
    <DialogInfoView ref="dialogInfoView" />
  </v-card>
</template>

<script>
import DetailGroupDialog from '@/modules/tuitionFee/detail-group/DetailGroupDialog'
import DialogInfoView from './DialogInfoView.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DetailGroupDialog,
    DialogInfoView
  },
  computed: {
    ...mapState({
      club: state => state.club.item
    })
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.description {
  width: 80%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  /* identical to box height, or 143% */
  /* icon, sub */
  color: #797979;
}
.text-name {
  /* H4 */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  /* identical to box height, or 133% */
  color: #000000;
}
</style>
